// extracted by mini-css-extract-plugin
module.exports = {"refGene":"refGeneExons-module__refGene___1wDHX","highlight":"refGeneExons-module__highlight___2cxbc","box":"refGeneExons-module__box___8K16n"};